import React, { useState } from "react";
import { Box } from "./seroPreviewStyle";
import { isInIframe } from "../../utils/is-in-iframe";
import { ToolsHeader } from "../components/ToolsHeader";
// import "./sero_preview.css";
const MAX_TITLE_LENGTH = 60;
const MAX_DESCRIPTION_LENGTH = 160;

const SerpPreviewSimulator: React.FC = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");
  const [keywords, setKeywords] = useState("");
  const [view, setView] = useState<"desktop" | "mobile">("desktop");
  const [loading, setLoading] = useState(false);

  const updateCharCount = (text: string, max: number): string => {
    return `(${text.length}/${max})`;
  };

  const boldKeywords = (text: string, keywords: string): string => {
    let result = text;
    keywords.split(/[\s,]+/).forEach((word) => {
      if (word.trim()) {
        const regex = new RegExp(`(${word.trim()})`, "gi");
        result = result.replace(regex, "<strong>$1</strong>");
      }
    });
    return result;
  };

  const handleFetchData = async () => {
    if (!url) {
      alert("Please enter a URL");
      return;
    }

    try {
      new URL(url);
    } catch {
      alert("Please enter a valid URL (e.g., https://example.com)");
      return;
    }

    setLoading(true);
    const corsProxies = [
      "https://corsproxy.io/?",
      "https://api.codetabs.com/v1/proxy?quest=",
    ];

    for (const proxy of corsProxies) {
      try {
        const response = await fetch(proxy + url);
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");

        const metaTitle = doc.querySelector("title")?.textContent || "";
        const metaDesc =
          doc
            .querySelector('meta[name="description"]')
            ?.getAttribute("content") ||
          doc
            .querySelector('meta[property="og:description"]')
            ?.getAttribute("content") ||
          "";

        setTitle(metaTitle.trim());
        setDescription(metaDesc.trim());
        setLoading(false);
        return;
      } catch (e) {
        continue;
      }
    }

    alert("Error fetching metadata. Please ensure the URL is correct.");
    setLoading(false);
  };

  const capitalizeTitle = () => {
    setTitle(title.replace(/\b\w/g, (c) => c.toUpperCase()));
  };

  const previewDescription = boldKeywords(
    description ||
      "Here is an example of what a snippet looks like in Google's SERPs. The content that appears here is usually taken from the Meta Description tag if relevant.",
    keywords
  );

  return (
    <Box>
      <div
        className={`container container_sero ${
          !isInIframe ? "defaultText" : "interDisplay"
        }`}
      >
        {!isInIframe && (
          <ToolsHeader
            title="SERP Preview Simulator"
            description="Simulate and preview your webpage’s appearance in search engine
                results for better SEO."
          />
        )}
        {/* <h1>SERP Preview Simulator</h1> */}
        <div className="grid">
          <div className="card">
            <div className="button-group">
              <button
                id="fetchData"
                onClick={handleFetchData}
                className="button button-primary"
                disabled={loading}
                style={{ backgroundColor: loading ? "#ccc" : "#8cc540" }}
              >
                <svg
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                {loading ? "Fetching..." : "Fetch Data"}
              </button>
              <button
                id="capitalizeTitle"
                onClick={capitalizeTitle}
                className="button button-primary"
                style={{ backgroundColor: loading ? "#ccc" : "#8cc540" }}
              >
                <svg
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
                Capitalize Title
              </button>
            </div>
            <div className="form-group">
              <label>
                Title Tag{" "}
                <span className="char-count">
                  {updateCharCount(title, MAX_TITLE_LENGTH)}
                </span>
              </label>
              <input
                type="text"
                value={title}
                maxLength={70}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter your title"
              />
            </div>
            <div className="form-group">
              <label>
                Meta Description{" "}
                <span className="char-count">
                  {updateCharCount(description, MAX_DESCRIPTION_LENGTH)}
                </span>
              </label>
              <textarea
                value={description}
                rows={3}
                maxLength={180}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter your meta description"
              ></textarea>
            </div>
            <div className="form-group">
              <label>URL</label>
              <input
                type="url"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://example.com"
              />
            </div>
            <div className="form-group">
              <label>Keywords to Bold (separate by spaces or commas)</label>
              <input
                type="text"
                value={keywords}
                onChange={(e) => setKeywords(e.target.value)}
                placeholder="Enter keywords"
              />
            </div>
          </div>

          <div className="serp-preview1">
            <div className="search-header uk-flex">
              <div className="search-logo">
                <img
                  decoding="async"
                  alt="Logo"
                  width="92"
                  src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png"
                />
              </div>
              <div className="formgoogle">
                <form action="#" className="serp-form-tag uk-position-relative">
                  <strong className="mg-label font-10 font-montserrat uk-position-top-left mg-margin-t-15 mg-margin-l-15">
                    {"TIP :"}
                  </strong>
                  <input
                    className="search-input"
                    placeholder="Enter a keyword to get real search results"
                    type="text"
                    // fdprocessedid="6jmtjf"
                  />
                </form>
                <div style={{ maxHeight: "22rem", overflow: "auto" }}>
                  <div className="search-menu uk-flex">
                    <div className="search-cat is-active">All</div>
                    <div className="search-cat">Images</div>
                    <div className="search-cat">Videos</div>
                    <div className="search-cat">News</div>
                    <div className="search-cat">Maps</div>
                    <div className="search-cat">More</div>
                  </div>

                  <div className="search-count">
                    About 608,000,000 results (0.54 seconds){" "}
                  </div>
                  <div className="serp-url" id="preview-url">
                    {url || "www.example.com"}
                  </div>
                  <div className="serp-title" id="preview-title">
                    {title || "www.example.com"}
                  </div>
                  <div
                    className="serp-description"
                    id="preview-description"
                    dangerouslySetInnerHTML={{ __html: previewDescription }}
                  ></div>
                  {(url === "" ? ["1"] : ["1", "2", "3"]).map((_a) => (
                    <div className="serp-result is-placeholder" key={_a}>
                      <div>
                        <span className="snippet-url uk-display-block"></span>
                      </div>
                      <div>
                        <span className="snippet-title uk-display-block"></span>
                      </div>
                      <div>
                        <span className="snippet-descr uk-display-block"></span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* <div className="card">

              <div className="button-group">
                <button
                  onClick={() => setView("desktop")}
                  className={`button button-secondary ${
                    view === "desktop" ? "active" : ""
                  }`}
                >
                  Desktop
                </button>
                <button
                  onClick={() => setView("mobile")}
                  className={`button button-secondary ${
                    view === "mobile" ? "active" : ""
                  }`}
                >
                  Mobile
                </button>
              </div>

              <div className={`serp-preview ${view} google-bg`}>
                <div className="serp-title">{title || "Title"}</div>
                <div className="serp-url">{url || "https://example.com"}</div>
                <div
                  className="serp-description"
                  dangerouslySetInnerHTML={{ __html: previewDescription }}
                ></div>
              </div>

              <div className="tips">
                <h3>Tips</h3>
                <ul>
                  <li>Keep titles between 50-60 characters</li>
                  <li>Meta descriptions should be 120-160 characters</li>
                  <li>Use 2-3 relevant keywords in your description</li>
                  <li>Ensure your URL is clean and descriptive</li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default SerpPreviewSimulator;
